import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/luban/p448jrzbdnxy/1*',
      meta: {
        dataPageId: ''
      },
      component: resolve => require(['./views/page1/index.vue'], resolve)
    },
    {
      path: '*'
    }
  ]
})

export default router
